export const LOCAL_STORAGE_KEY = 'social_app_session';
